<template>
    <div>
        <div class="text-center alter alert-success">
            {{ $t('reset_cart') }}
        </div>
    </div>
</template>
<script>

    import { mapActions } from 'vuex';

    export default {
        name: 'ResetCart',
        mounted() {
            this.resetCartAction();
        },
        methods: {
            ...mapActions({
                resetCartAction: 'cart/resetCart'
            })
        }
    }
</script>
